export default "__VITE_ASSET__DdS6gYpT__"